<button type="button" class="border-0 bg-transparent w-100 px-0 mt-3" (click)="openScorecardDescription()">
  <div class="badge-container d-flex flex-column justify-content-center align-items-center">
    <div
      class="badge-image"
      [ngClass]="{
        'badge-incomplete': badge?.Status != BadgeStatus.Completed,
        'mb-3': isShowName,
        'mb-lg-3 mb-1': !isShowName,
      }"
    >
      <img [src]="badge?.Badge | contentImage: '7' : 'badge'" [useDefault]="true" [loyaltyType]="'badge'" alt="" />
      <span
        *ngIf="badge?.Status == BadgeStatus.Completed && badge.NumberOfCompletions > 1"
        class="badge-completion-numbers-div translate-middle badge rounded-pill"
      >
        {{ badge.NumberOfCompletions }}
        <span class="visually-hidden">unread messages</span>
      </span>
    </div>
    <ng-container *ngIf="isShowName">
      <div class="badge-title px-1 scorecard-label-ellipsis text-center">
        {{ badge?.Content[0].Name }}
      </div>
    </ng-container>
  </div>
</button>
